import React, { useEffect, useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { Avatar, Box, Button, Fab, Paper, Skeleton, Typography } from '@mui/material';
import Grid from '@mui/material/Grid';
import { useAuth } from '../../hooks/useAuth';
import { makeStyles } from '@mui/styles';
import MaterialSelectAuto from './mat-select-auto';
import { DeletedBuyMaterial, buyMatUpdate, getBuyMaterils } from '../../services/material-services';
import AddShoppingCartIcon from '@mui/icons-material/AddShoppingCart';
import { CssTextField } from '../layout/elements';
import {NotificationManager} from 'react-notifications';
import PriceCheckIcon from '@mui/icons-material/PriceCheck';
import SuperscriptIcon from '@mui/icons-material/Superscript';
import DeleteIcon from '@mui/icons-material/Delete';
import SupervisedUserCircleIcon from '@mui/icons-material/SupervisedUserCircle';
import MonetizationOnIcon from '@mui/icons-material/MonetizationOn';
import ArrowLeftIcon from '@mui/icons-material/ArrowLeft';
// import ProgressWait from '../layout/progress';
import HomeIcon from '@mui/icons-material/Home';
import SelectLang from './mat_lang-select';
import { grey } from '@mui/material/colors';



const useStyles = makeStyles( theme => ({
    header_dtl: {
        fontFamily: 'Segoe UI',
        marginRight: '10px',
        marginTop: '10px',
        color: theme.mainAccentColor
    },
    memberContainer:{
      display: 'grid',
      gridTemplateColumns: '100px auto'
    },
    image_cover:{
        height:500, 
        width:'100%', 
        paddingLeft: '-2rem',
        paddingRight: '-1rem',
    }
}));


function MaterialBuyAdd() {
    
    const { authData, authDataGroup, authDataLang } = useAuth();
    const [isAdmin, setIsAdmin] = useState(false);
    const [statusReq, setStatusReq ] = useState(false);

    const location = useLocation();
    const { state } = location;

    const [remarks, setRemarks ] = useState('');
    const [matName, setMatName ] = useState('');
    const [matLang, setMatLang ] = useState(0);
    const [matBuy, setMatBuy ] = useState('');
    const [matID, setMatID ] = useState(0);
    const [matDetailID, setMatDetailID ] = useState(0);
    const [matBuyMoney, setMatBuyMoney ] = useState(0);
    const [matBuyCount, setMatBuyCount ] = useState(1);
    const [matSellMoney, setMatSellMoney ] = useState(0);
    const [persentage, setPersentage ] = useState(15);
    const [matBio, setMatBio ] = useState('');
    // const [error, setError] = useState(false);
    const [loading, setLoading] = useState(false);
    const [matHashTag, setMatHashTag ] = useState('');
    const [langID, setLangID ] = useState(0);

    const cssClass = useStyles();
    const navigate = useNavigate();

    const handelSubmitData = async e => {
        e.preventDefault();
        setLoading(true);
        const uploaddata = new FormData();
        if(matDetailID){
            uploaddata.append('id', matDetailID);
        }
        if(matID){
            uploaddata.append('buy_mat', matID);
        }
        if(matName?.id){
            uploaddata.append('material', matName?.id);
        }else{
            NotificationManager.warning('لطفا نام فعالیت را انتخاب کنید')
            return
        }
        if(matBio){
            uploaddata.append('bio', matBio);
        }
        if(matBuyMoney){
            uploaddata.append('buy_money', matBuyMoney);
        }
        if(matBuyCount){
            uploaddata.append('buy_count', matBuyCount);
        }
        if(remarks){
            uploaddata.append('remarks', remarks);
        }
        if(matSellMoney){
            uploaddata.append('sell_cash', matSellMoney);
        }
        if(matLang){
            uploaddata.append('lang_id', matLang);
        }else{
            NotificationManager.warning('لطفا زبان را انتخاب کنید')
            return
        }

        const addNewBuyMaterial = await buyMatUpdate(authData.token, uploaddata);
        // console.log(addNewBuyMaterial);
        if (addNewBuyMaterial){
            NotificationManager.success('کالای جدید به برنامه اضافه شد');
        }else{
            NotificationManager.error('متاسفانه خطایی در زمان ثبت محصول وجود دارد');
        }
        setLoading(false);
    }

    // const handelSubmit = async e => {
    //     e.preventDefault();
    //     console.log(matName)
    //     const addNewMaterial = await buyNewMat(authData.token, {
    //         'material': matName, 'bio': matBio, 'buy_money': matBuyMoney, 'buy_count': matBuyCount
    //         , 'remarks': remarks, 'sell_cash':matSellMoney});
            
    //     if (addNewMaterial){
    //         NotificationManager.success('کالای جدید به برنامه اضافه شد');
    //     }else{
    //         NotificationManager.error('متاسفانه خطایی در زمان ثبت محصول وجود دارد');
    //     }
    // }

    const handleClose = (value) => {
        setMatName(value);
    };

    const handleSelectLang = (value) => {
        // console.log(value);
        setMatLang(value?.id);
    };
      
    useEffect(() => {
        if(authData?.user){
            setIsAdmin(authData?.user?.profile?.is_permium);
        }
        if(state?.material?.hash_tag){
            setMatHashTag(state?.material?.hash_tag);
        }
        if(state?.lang){
            setLangID(state?.lang);
        // }else{
        //     NotificationManager.warning('لطفا زبان را انتخاب کنید')
        }
        // console.log('buy', state);
        if (state?.id){
            setStatusReq(true);
            setMatDetailID(state?.id);
        }
        if (state?.buy_mat){
            setMatID(state.buy_mat);
        }
        if (state?.material?.name){
            setMatName(state.material);
        }
        if (state?.lang){
            setMatLang(state.lang);
        }
        
        if (state?.buy_count){
            setMatBuyCount(state?.buy_count);
        }
        if (state?.buy_money){
            setMatBuyMoney(state?.buy_money);
        }
        if (state?.sell_cash){
            setMatSellMoney(state?.sell_cash);
        }
        
        if(state?.buy_mat)
        {
            setLoading(true);
            const getData = async() =>{
                await getBuyMaterils(authData.token, state?.buy_mat)
                .then(data => {
                    setMatBuy(data);
                    setRemarks(data?.remarks)
                    setMatBio(data?.bio)
                    setLoading(false);
                    // console.log('row', data);
                    // setError(false);
                }).catch( e => {
                    // setError(true);
                    setLoading(false);
                })
            }
            getData();
        }

        window.scrollTo(0, 0);
    }, [state, authData]);

    const submitDelete = async e =>{
        setLoading(true);
        if(matDetailID <= 0){
            NotificationManager.warning('لطفا نام فعالیت را انتخاب کنید')
            return
        }
        const delMaterial = await DeletedBuyMaterial(authData?.token, {'buy_id' : matDetailID});
        // const delMaterial = await DeletedBuyMaterial(authData?.token, {'buy_id' : matDetailID});
        if (delMaterial){
            NotificationManager.success('خرید با موفقیت حذف شد');
        }else{
            NotificationManager.error('متاسفانه خطایی در زمان حذف خرید وجود دارد');
        }
        setMatName(null);
        setLoading(false);
        navigate('/');
    }
    
    // if (loading) return <ProgressWait statusWait={true}/> 

  return (
    <React.Fragment>
    <div  dir={authDataLang?.view_sts ? "rtl" : "ltr"}>
        <Link to={`/${authDataGroup?.name}/#${matHashTag}`}>
            <Avatar >
                <HomeIcon color='primary' sx={{ fontSize: 40}}/>
            </Avatar> 
        </Link>
        <div style={{display: 'grid', gridTemplateColumns: '1fr 10rem'}}>
            <h1 className={cssClass.header_dtl}>کنترل خرید</h1>
            {isAdmin && statusReq &&
                <Fab variant="extended" 
                    size="small" color="secondary" 
                    aria-label="add" 
                    sx={{
                        textAlign: 'right',
                    }}
                    onClick={submitDelete}
                    >
                    <DeleteIcon sx={{ mr: 1 }} />
                    <Typography
                        fontFamily='b_mitra' 
                        component="div"
                        variant="h5"
                        >
                        حذف
                    </Typography>
                </Fab>
            }
        </div>
        <hr/>
        <Box 
            sx={{
                p: 2,
                bgcolor: '#E7EBF0',
                display: 'block',
                gap: 2,
                width: '100%',
                minHeight: 1000
              }}
            >
            <Paper elevation={3} sx={{
                        marginBottom: '1rem',
                        marginTop: '1rem',
                        paddingTop: '1rem',
                    }} >
            {loading ?
              <Box sx={{ width: '100%' }}>
                  <Skeleton />
                  <Skeleton variant="rectangular" width='100%' height={300} />
                  <Skeleton animation="wave" />
                  <Skeleton animation={false} />
                  <Skeleton variant="circular" width={40} height={40} />
                  <Skeleton variant="rounded" width='100%' height={150} />
              </Box>
            :    
            <form onSubmit={handelSubmitData}>
                <Grid container spacing={1} alignItems='flex-end' sx={{ my: 2 }}>
                    <Grid item>
                        <AddShoppingCartIcon sx={{ color: 'action.active', mr: 1, my: 0.5 }} />
                    </Grid>
                    <Grid item >
                        <SelectLang 
                            onChange={handleSelectLang} 
                            selectedValue={matLang} />
                    </Grid>
                    <Grid item>
                        *
                    </Grid>
                </Grid>
                <Grid container spacing={1} alignItems='flex-end' sx={{ my: 2 }}>
                    <Grid item>
                        <AddShoppingCartIcon sx={{ color: 'action.active', mr: 1, my: 0.5 }} />
                    </Grid>
                    <Grid item >
                        <MaterialSelectAuto 
                            onChange={handleClose} 
                            selectedValue={matName} />
                    </Grid>
                    <Grid item>
                        *
                    </Grid>
                </Grid>
                

                <Grid container spacing={1} alignItems='flex-end' sx={{ my: 2 }}>
                    <Grid item>
                        <SupervisedUserCircleIcon sx={{ color: 'action.active', mr: 1, my: 0.5 }} />
                    </Grid>
                    <Grid item xs={10}>
                        <CssTextField id="text-buy-count" 
                            label={(
                                <Typography 
                                    fontFamily='b_mitra' 
                                    component="div"
                                    variant="h6"
                                    color={grey[500]}
                                    >
                                    تعداد*
                                </Typography>
                            )}                            
                            variant="standard" value={matBuyCount}
                            onChange={ e => setMatBuyCount( e.target.value )} />
                    </Grid>
                </Grid>
                <hr/>
                <Grid container spacing={1} alignItems='flex-end' sx={{ my: 2 }}>
                    <Grid item>
                        <MonetizationOnIcon sx={{ color: 'action.active', mr: 1, my: 0.5 }} />
                    </Grid>
                    <Grid item xs={10}>
                        <CssTextField id="text-money-buy" 
                            label={(
                                <Typography 
                                    fontFamily='b_mitra' 
                                    component="div"
                                    variant="h6"
                                    color={grey[500]}
                                    >
                                    قیمت خرید*
                                </Typography>
                            )}
                            variant="standard" value={matBuyMoney}
                            onChange={ e => setMatBuyMoney( e.target.value )} />
                    </Grid>
                </Grid>
                <Grid container spacing={1} alignItems='flex-end' sx={{ my: 2 }}>
                    <Grid item>
                        <PriceCheckIcon sx={{ color: 'action.active', mr: 1, my: 0.5 }} />
                    </Grid>
                    <Grid item xs={10}>
                        <CssTextField id="text-sell-money" 
                            label={(
                                <Typography 
                                    fontFamily='b_mitra' 
                                    component="div"
                                    variant="h6"
                                    color={grey[500]}
                                    >
                                    قیمت فروش*
                                </Typography>
                            )}
                            variant="standard"  value={matSellMoney}
                            onChange={ e => setMatSellMoney( e.target.value )} />
                    </Grid>
                </Grid>
                <Grid container spacing={1} alignItems='flex-end' sx={{ my: 2 }}>
                    <Grid item>
                        <SuperscriptIcon sx={{ color: 'action.active', mr: 1, my: 0.5 }} />
                    </Grid>
                    <Grid item xs={10}>
                        <CssTextField id="text-sell-persantage" 
                            label={(
                                <Typography 
                                    fontFamily='b_mitra' 
                                    component="div"
                                    variant="h6"
                                    color={grey[500]}
                                    >
                                    درصد فروش
                                </Typography>
                            )}
                            variant="standard" value={persentage}
                            onChange={ e => setPersentage( e.target.value )} />
                    </Grid>
                </Grid>
                <hr/>
                <Grid container spacing={1} alignItems='flex-end' sx={{ my: 2 }}>
                    <Grid item>
                        <ArrowLeftIcon sx={{ color: 'action.active', mr: 1, my: 0.5 }} />
                    </Grid>
                    <Grid item xs={10}>
                        <CssTextField id="text-buy-bio" 
                            label={(
                                <Typography 
                                    fontFamily='b_mitra' 
                                    component="div"
                                    variant="h6"
                                    color={grey[500]}
                                    >
                                    مشخصات
                                </Typography>
                            )}
                            
                            variant="standard" value={matBio}
                            onChange={ e => setMatBio( e.target.value )} />
                    </Grid>
                </Grid>
                <Grid container spacing={1} alignItems='flex-end' sx={{ my: 2 }}>
                    <Grid item sx={{marginTop: '1fr', marginBottom: 'auto',}}>
                        <ArrowLeftIcon sx={{ color: 'action.active', mr: 1, my: 0.5 }} />
                    </Grid>
                    <Grid item xs={10}>
                        <CssTextField id="text-buy-remarks" 
                            label={(
                                <Typography 
                                    fontFamily='b_mitra' 
                                    component="div"
                                    variant="h6"
                                    color={grey[500]}
                                    >
                                    توضیحات
                                </Typography>
                            )}
                            multiline
                            fullWidth
                            rows={4} 
                            className={cssClass.header_dtl}
                            variant="standard" value={remarks}
                            onChange={ e => setRemarks( e.target.value )} />
                    </Grid>
                </Grid>
                <hr/>
                <Button sx={{paddingLeft: 5, paddingRight: 5, margin: 5}} 
                    variant="contained" color="primary" type='submit'
                    disabled={!matName || !matBuyMoney || !matBuyCount || !matSellMoney}>
                    <Typography
                        fontFamily='b_mitra' 
                        component="div"
                        variant="h4"
                        >
                        ثبت
                    </Typography>
                </Button>
            </form>
            }
        </Paper>
        </Box>
    </div>
    </React.Fragment>
  );
}

export default MaterialBuyAdd;
